import React from "react";
import ApexCharts from "react-apexcharts";
import DatePicker  from "react-datepicker";

const Chart = ({data,header,startDate,handleChangStartDate}) => {

  
  var options = {
    series: [
      {
        name: "series1",
        data: [200, 400, 300, 400, 200, 400, 200, 300, 200, 300],
      },
      {
        name: "series2",
        data: [500, 300, 400, 200, 500, 200, 400, 300, 500, 200],
      },
      {
        name: "series2",
        data: [300, 200, 600, 300, 600, 300, 500, 400, 300, 600],
      },
    ],
    chart: {
      height: 300,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    colors: ["#FFAB2D", "#00ADA3", "#71B945"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    legend: {
      show: true,
    },
    grid: {
      show: false,
      strokeDashArray: 6,
      borderColor: "#dadada",
    },
    yaxis: {
      labels: {
        style: {
          colors: "#B5B5C3",
          fontSize: "15px",
          fontFamily: "Poppins",
          fontWeight: 400,
        },
        formatter: function (value) {
          return value + "k";
        },
      },
    },
    xaxis: {
      categories: [
        "Week 01",
        "Week 02",
        "Week 03",
        "Week 04",
        "Week 05",
        "Week 06",
        "Week 07",
        "Week 08",
        "Week 09",
        "Week 10",
      ],
      labels: {
        style: {
          colors: "#B5B5C3",
          fontSize: "12px",
          fontFamily: "Poppins",
          fontWeight: 400,
        },
      },
    },
    fill: {
      type: "solid",
      opacity: 3,
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  };

  // const handleChangStartDate =() => {

  // }

  return (
    <>
      <div className="row">
        <div className="col-lg-12 ">
          <div className="card">
            <div className="card-header border-0 flex-wrap pb-0">


              <h4 className="fs-20 text-black ">{header}</h4>
              <div>
                   <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
           

              {/* <div className="row">
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#EB8153"></rect>
                  </svg>
                  <span className="fs-14">East (%)</span>
                </div>
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#4A8CDA"></rect>
                  </svg>
                  <span className="fs-14">Esan (%)</span>
                </div>
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#71B945"></rect>
                  </svg>
                  <span className="fs-14">{"St>3 m (%)"}</span>
                </div>
              </div> */}

              {/* <select className="style-1 btn-secondary default-select">
                <option>Quarter (1)</option>
                <option>Quarter (2)</option>
                <option>Quarter (3)</option>
                <option>Quarter (4)</option>
              </select> */}
            </div>
            <div className="card-body pb-2 px-3">
              <div id="marketChart" className="market-line">
                <ApexCharts
                  options={data}
                  series={data.series}
                  height={350}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-12">
          <div className="card">
            <div className="card-header border-0 flex-wrap pb-0">
              <h4 className="fs-20 text-black">Woodchip Storage 1</h4>
              <div className="row">
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#EB8153"></rect>
                  </svg>
                  <span className="fs-14">East (%)</span>
                </div>
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#4A8CDA"></rect>
                  </svg>
                  <span className="fs-14">Esan (%)</span>
                </div>
                <div className="col-auto">
                  <svg
                    className="mr-2"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="15" height="15" rx="7.5" fill="#71B945"></rect>
                  </svg>
                  <span className="fs-14">{"St>3 m (%)"}</span>
                </div>
              </div>
              <select className="style-1 btn-secondary default-select">
                <option>Quarter (1)</option>
                <option>Quarter (2)</option>
                <option>Quarter (3)</option>
                <option>Quarter (4)</option>
              </select>
            </div>
            <div className="card-body pb-2 px-3">
            <div id="marketChart" className="market-line">
              <ApexCharts
                options={options}
                series={options.series}
                height={350}
              />
            </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Chart;
